import useSubscriptions from '@/context/SubscriptionContext';

export const name = 'money_bfcm-mode-2025';

export function useRule(flagValue: any) {
  const { data } = useSubscriptions();
  const isActiveSubscriber = Boolean(data?.isActiveSubscriber);
  const isAgedOutSubscriber = Boolean(data?.isAgedOutSubscriber);

  if (flagValue === 'off') {
    return false;
  }

  if (flagValue === 'all') {
    return true;
  }

  if (flagValue === 'presale') {
    return isActiveSubscriber || isAgedOutSubscriber; // PlayKit Subscribers only
  }

  return false;
}
